/* eslint-disable react/jsx-key */
import { useDataContext } from "./DataProvider";
import { CancelIcon } from "./icons/CancelIcon";
import { ClockIcon } from "./icons/ClockIcon";
import { EmptyStarIcon } from "./icons/EmptyStarIcon";

export const ShortBenefitsList = () => {
	const { companyInfo } = useDataContext();
	const { companyName, shortBenefitsList } = companyInfo;
	if (!shortBenefitsList) return null;

	const icons = [<EmptyStarIcon />, <ClockIcon />, <CancelIcon />];

	return (
		<div className="tw:w-full tw:rounded-lg tw:bg-white tw:px-4 tw:py-2 tw:lg:py-4">
			<p className="tw:mb-2 tw:text-base tw:leading-6 tw:font-bold tw:tracking-[-0.18px] tw:lg:mb-4 tw:lg:text-xl">
				Why Choose {companyName}?
			</p>
			<ul>
				{shortBenefitsList.map((benefit, index) => {
					let icon = icons[index % icons.length];

					return (
						<li
							key={index}
							className="tw:mb-1 tw:flex tw:items-center tw:text-sm tw:font-semibold tw:lg:mb-2"
						>
							<span className="tw:inline-flex tw:text-2xl tw:text-[#E1255B]">
								{icon}
							</span>
							<span className="tw:ml-2">{benefit}</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
